<!-- 骨架基础样式组件 -->
<script lang="ts">
  export let width = '100%';
  export let height = '25px';
  export let baseColor = 'rgb(246, 246, 246)';
  export let highlightColor = 'rgb(252, 252, 252)';
  export let borderRadius = '4px';
  export let animationLength = '1.4s';
  // 内置的颜色模式，是一组 baseColor 和 highlightColor 的组合
  export let colorMode: 'black' = '';
  export let style = '';

  export {className as class};
  let className = '';

  $: restProps = {...($$restProps || {})};
  $: {
    if (colorMode === 'black') {
      baseColor = '#1a1a1a';
      highlightColor = '#343434';
    }
  }
</script>

<style>
  .skeleton {
    display: block;
    box-sizing: border-box;
    width: 100%;
    background-image: linear-gradient(90deg, var(--baseColor) 25%, var(--highlightColor) 37%, var(--baseColor) 63%);
    background-size: 400% 100%;
    background-repeat: no-repeat;
    background-color: var(--baseColor);
    animation: loading-animation var(--animationLength) ease infinite;
  }
  .skeleton[hidden='true'] {
    display: none;
  }
  @keyframes loading-animation {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }
</style>

<div
  class="skeleton {className}"
  {...restProps}
  style="height: {height}; width: {width}; border-radius: {borderRadius}; --baseColor: {baseColor}; --highlightColor: {highlightColor}; --animationLength: {animationLength}; {style}"
/>
